import slugify from "slugify";

function alpha_numeric_filter(string) {
  const alpha_numeric = Array.from(
    " abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
  );

  const json_string = JSON.stringify(string);

  let filterd_string = "";

  for (let i = 0; i < json_string.length; i++) {
    let char = json_string[i];
    let index = alpha_numeric.indexOf(char);
    if (index > -1) {
      filterd_string += alpha_numeric[index];
    }
  }

  return filterd_string;
}

const slugifyString = (string) => {
  return slugify(alpha_numeric_filter(string).toLowerCase());
};

export default slugifyString;
